import React from 'react';
import { Menu, Item, Separator, useContextMenu } from 'react-contexify';
import 'react-contexify/ReactContexify.css';

import SubscribersActions from './SubscribersActions';
import Table from '../../../Table';

const MENU_ID = 'subscriber-context-menu';

const List = ({
	subscribersTemplate,
	list,
	I18n,
	handleSubscriberData,
	onChangeStatus,
	deleteSubscriber,
	isLoading,
	code,
	counter,
	headerFields,
	GlobalFilter,
	setGlobalFilter,
	onMainCheckerClick,
	selectAll,
	onCheckChange,
	onSendConfirmationEmail,
	onRejectMassive,
	onDeleteMassive,
}) => {
	const { show } = useContextMenu({ id: MENU_ID });

	let filteredList = [];
	if (GlobalFilter === 'ALL') {
		filteredList = list;
	} else {
		filteredList = list.filter((record) => record.status === GlobalFilter);
	}

	const handleContextMenu = (event) => {
		show({ event });
	};

	return (
		<div className="row">
			<div className="subscribers-header">
				<div className="subscribers-filter">
					<label
						className="rdiobox"
						onClick={() => {
							setGlobalFilter('ALL');
						}}
					>
						<input name="rdio" type="radio" defaultChecked /> <span>Todos</span>
					</label>
					<label
						className="rdiobox"
						onClick={() => {
							setGlobalFilter('approved');
						}}
					>
						<input name="rdio" type="radio" /> <span>Aprobados</span>
					</label>
					<label
						className="rdiobox"
						onClick={() => {
							setGlobalFilter('pending');
						}}
					>
						<input name="rdio" type="radio" /> <span>Pendientes</span>
					</label>
					<label
						className="rdiobox"
						onClick={() => {
							setGlobalFilter('rejected');
						}}
					>
						<input name="rdio" type="radio" /> <span>Rechazados</span>
					</label>
				</div>
				<div className="subscribers-total">
					<div>
						<h1>{counter.approved + counter.pending + counter.rejected}</h1>
						<h6>Total Suscritos</h6>
					</div>
					<div>
						<h1>{counter.approved}</h1>
						<h6>Aprobados</h6>
					</div>
					<div>
						<h1>{counter.pending}</h1>
						<h6>Pendientes</h6>
					</div>
					<div>
						<h1>{counter.rejected}</h1>
						<h6>Rechazados</h6>
					</div>
				</div>
			</div>
			<div className="col-md-12 subscribers-table">
				<div className="subscribers-checkbox-main">
					<div className="subscribers-checkbox">
						<button
							className={selectAll ? 'selected' : ''}
							onClick={onMainCheckerClick}
						>
							<i
								className={selectAll ? 'fas fa-check-square' : 'far fa-square'}
							/>
						</button>
					</div>
					<button
						className="subscriber-context-menu-button btn btn-sm btn-outline-secondary"
						onClick={handleContextMenu}
					>
						Acciones <i className="fas fa-sort-down" />
					</button>
					<SubscriberContextMenu
						onSendConfirmationEmail={onSendConfirmationEmail}
						onDeleteMassive={onDeleteMassive}
						onRejectMassive={onRejectMassive}
					/>
				</div>
				<Table
					list={filteredList}
					filterFunction={(record) => {
						let _str = record.email + record.code;
						headerFields.forEach((row) => {
							if (row.parameter) {
								_str += ' ' + record[row.parameter];
							}
						});
						_str += record.timeLabel;
						return _str;
					}}
					defaultSorter={{ parameter: 'time', order: 'DESC' }}
					iterateFunction={(subscriber, index) => {
						return (
							<tr key={`${subscriber.id}`} className="subscriber-row">
								<td className="subscribers-checkbox">
									{subscriber.status === 'approved' && (
										<label className="ckbox">
											<input
												type="checkbox"
												data-id={subscriber.id}
												data-name={subscriber.displayName}
												data-email={subscriber.email}
												data-password={subscriber.password}
												data-code={subscriber.code}
												onChange={(e) => {
													onCheckChange(e, subscriber);
												}}
											/>{' '}
											<span></span>
										</label>
									)}
								</td>
								<td>
									<SubscribersActions
										status={subscriber.status}
										subscriber={subscriber}
										isLoading={isLoading}
										handleSubscriberData={handleSubscriberData}
										onChangeStatus={onChangeStatus}
										deleteSubscriber={deleteSubscriber}
									/>
								</td>
								<td className="name-cell">
									<img src={subscriber.photoURL} alt="subscriber avatar" />
									<div>
										<h5>{subscriber.displayName}</h5>
										<h6 className="subscriber-email">{subscriber.email}</h6>
									</div>
								</td>
								{code && <td>{subscriber.code}</td>}
								{subscribersTemplate.map((row, index) => {
									return (
										<td key={`${row.index}_${index}`}>
											{subscriber[row.index]}
										</td>
									);
								})}
								<td>{I18n('SUBSCRIBERS', subscriber.status)}</td>
								<td>{subscriber.timeLabel}</td>
							</tr>
						);
					}}
					fields={headerFields}
				/>
			</div>
		</div>
	);
};

export default List;

const SubscriberContextMenu = ({
	onSendConfirmationEmail,
	onRejectMassive,
	onDeleteMassive,
}) => {
	return (
		<Menu id={MENU_ID}>
			<Item onClick={onSendConfirmationEmail}>
				Enviar correo de confirmación
			</Item>
			<Separator />
			<Item onClick={onRejectMassive}>Anular Aprobación</Item>
			<Item onClick={onDeleteMassive}>Eliminar</Item>
		</Menu>
	);
};
